import { create } from 'zustand';

export type CanvasCollabMode = 'default' | 'commitOnDrop' | 'livePreview';

interface CanvasCollabUiState {
  mode: CanvasCollabMode;
  ghosts: Record<string, { x: number; y: number }>;
  setMode: (mode: CanvasCollabMode) => void;
  setGhost: (equipmentId: string, position: { x: number; y: number } | null) => void;
  clearGhosts: () => void;
}

export const useCanvasCollabStore = create<CanvasCollabUiState>((set) => ({
  mode: 'default',
  ghosts: {},
  setMode: (mode) => set({ mode }),
  setGhost: (equipmentId, position) => {
    set((state) => {
      if (!position) {
        const next = { ...state.ghosts };
        delete next[equipmentId];
        return { ghosts: next };
      }
      return { ghosts: { ...state.ghosts, [equipmentId]: position } };
    });
  },
  clearGhosts: () => set({ ghosts: {} }),
}));
